const { userAgent } = require('./deviceInfo');

const isSafari = (function isSafari() {
    if (userAgent) {
        const containsSafari = userAgent.toLowerCase().indexOf('safari') > -1;
        const containsChrome = userAgent.toLowerCase().indexOf('chrome') > -1;
        const containsChromium =
            userAgent.toLowerCase().indexOf('chromium') > -1;

        return containsSafari && !containsChrome && !containsChromium;
    }

    return false;
})();

const isFirefox = (function isFirefox() {
    if (userAgent) {
        const containsFirefox = userAgent.toLowerCase().indexOf('firefox') > -1;
        const containsSeamonkey =
            userAgent.toLowerCase().indexOf('seamonkey') > -1;

        return containsFirefox && !containsSeamonkey;
    }

    return false;
})();

const isChrome = (function isChrome() {
    if (userAgent) {
        const containsEdge =
            userAgent.indexOf('Edge') > -1 ||
            userAgent.toLowerCase().indexOf('edg/') > -1;
        const containsChrome = userAgent.toLowerCase().indexOf('chrome') > -1;

        // https://stackoverflow.com/questions/4565112/javascript-how-to-find-out-if-the-user-browser-is-chrome/13348618#13348618
        // Edge will return true for Safari and Chrome, so adding a check for !(Edge) will make this only return true for users on Chrome

        return containsChrome && !containsEdge;
    }

    return false;
})();

const isEdge = (function isEdge() {
    if (userAgent) {
        const containsEdge = userAgent.toLowerCase().indexOf('edg/') > -1;

        return containsEdge;
    }

    return false;
})();

export { isSafari, isFirefox, isChrome, isEdge };
